import axios from 'axios';
import { ProductInventory } from 'types';

export const fetchProductInventory = (brandId: number, productId: number) => {
  return axios.get<ProductInventory>(
    `/api/brands/${brandId}/products/${productId}/inventory`
  );
};
